<template>
	<div class="portfolio-buttons">
		<button
			type="button"
			class="btn text-center"
			:class="{ active: currentPortfolio === null, 'delete-mode': showDeleteButton }"
			@click="select(null)"
			v-if="showAllButton"
		>
			<strong>Všetky</strong>
			<strong>portfóliá</strong>
			<font-awesome-icon icon="times" class="text-danger btn-delete" v-if="showDeleteButton" />
		</button>
		<button
			v-for="portfolio in portfolios"
			type="button"
			class="btn"
			:class="{
				active: currentPortfolio !== null && currentPortfolio.portfolio === portfolio.portfolio,
				'delete-mode': showDeleteButton,
			}"
			@click="select(portfolio)"
            v-bind:key="portfolio.portfolio"
		>
			<strong>{{ portfolio.description }}</strong>
			<span
				>{{ portfolio.portfolio }} ({{ portfolio.amount | number }} <small>{{ portfolio.currency }}</small
				>)</span
			>
			<font-awesome-icon icon="times" class="text-danger btn-delete" v-if="showDeleteButton" />
		</button>
	</div>
</template>

<script>
export default {
	name: "PortfolioButtons",
	props: {
		showAllButton: {
			type: Boolean,
			required: false,
			default: true,
		},
		showDeleteButton: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	computed: {
		portfolios() {
			return this.$store.state.portfolio.items;
		},
		currentPortfolio() {
			return this.$store.state.portfolio.selected;
		},
	},
	mounted() {
		this.$store.dispatch("portfolio/portfolios");
	},
	methods: {
		select(data) {
			if (this.showDeleteButton === false) {
				this.$store.commit("portfolio/select", data);
				//this.$store.dispatch("portfolio/loadPortfolio");
				this.$emit("selected", data);
			} else {
				this.$emit("delete", data);
			}
		},
	},
};
</script>

<style lang="scss">
@import "@/assets/styles/variables.scss";

.portfolio-buttons {
	.btn:not(.btn-primary) {
		border-radius: 8px;
		border: 1px solid #a0a0a0;
		color: #fff !important;
		line-height: 120%;
		font-size: 13px;
		padding: 5px 20px;
		box-shadow: none;
		outline: none;
		margin-right: 10px;
		margin-bottom: 10px;
		text-align: left;
		position: relative;

		&.delete-mode {
			padding-right: 35px;
		}

		&.active {
			border-color: $blue;
		}

		strong {
			display: block;
		}

		span {
			color: #bbb;
		}

		.btn-delete {
			position: absolute;
			right: 10px;
			top: 50%;
			margin-top: -8px;
		}


	}

    .transactions-type-picker, .transactions-date-picker {
        .btn-sm {
            height: 28px !important;

            @include media-breakpoint-down(md) {
                height: 40px !important;
            }
        }
    }
}
</style>
